// extracted by mini-css-extract-plugin
module.exports = {"inputMoons":"InputMoons_inputMoons__35MP2"};